/*eslint-disable*/
import React from 'react'
import moment from 'moment'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import InputAdornment from '@material-ui/core/InputAdornment'
import { CircularProgress, Select, MenuItem, Fade } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import IconButton from '@material-ui/core/IconButton'

// material ui icons
import SupervisorAccount from '@material-ui/icons/SupervisorAccount'
import AddAlert from '@material-ui/icons/AddAlert'
import Close from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import GroupIcon from '@material-ui/icons/Group'
import ClearIcon from '@material-ui/icons/Clear'

// core components
import Heading from 'components/Heading/Heading.js'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import CustomInput from 'components/CustomInput/CustomInput.js'
import Button from 'components/CustomButtons/Button.js'
import Card from 'components/Card/Card.js'
import CardHeader from 'components/Card/CardHeader.js'
import CardIcon from 'components/Card/CardIcon.js'
import CardBody from 'components/Card/CardBody.js'
import Snackbar from 'components/Snackbar/Snackbar.js'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'

import { formatDate } from '../../../utils/functions.js'

// style for this view
import styles from 'assets/jss/material-dashboard-pro-react/views/User/createStyle.js'

const useStyles = makeStyles(styles)

export default function editView(props) {
  const classes = useStyles()
  if (props.pageIsLoading) {
    return <div></div>
  }

  const breadcrumbViews = [
    {
      name: 'Users',
      url: `/admin/users/index`,
      icon: GroupIcon
    },
    {
      name: 'Edit User',
      url: `/admin/users/edit/${props.tenantId}/${props.userId}`,
      icon: EditIcon
    }
  ]

  return (
    <Fade in={true} timeout={250}>
      <div>
        <Breadcrumbs views={breadcrumbViews} />
        <Heading textAlign="center" title="Edit User" />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <SupervisorAccount />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Edit</h4>
                <IconButton
                  style={{ float: 'right' }}
                  color="primary"
                  component="span"
                  onClick={() => props.onClear()}
                >
                  <ClearIcon />
                </IconButton>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            success={props.userState.firstName === 'success'}
                            error={props.userState.firstName === 'error'}
                            labelText="First Name*"
                            id="inputFirstName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event => {
                                props.onFieldChange('firstName', event.target.value)
                              },
                              type: 'text',
                              value: props.user.firstName,
                              endAdornment:
                                props.userState['firstName'] === 'error' ? (
                                  <InputAdornment position="end">
                                    <Close className={classes.danger} />
                                  </InputAdornment>
                                ) : (
                                  undefined
                                )
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            success={props.userState.lastName === 'success'}
                            error={props.userState.lastName === 'error'}
                            labelText="Last Name*"
                            id="inputLastName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event => {
                                props.onFieldChange('lastName', event.target.value)
                              },
                              type: 'text',
                              value: props.user.lastName,
                              endAdornment:
                                props.userState['lastName'] === 'error' ? (
                                  <InputAdornment position="end">
                                    <Close className={classes.danger} />
                                  </InputAdornment>
                                ) : (
                                  undefined
                                )
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="multiple-select" className={classes.selectLabel}>
                              Role*
                            </InputLabel>
                            <Select
                              labelId="multiple-select"
                              id="multiple-select"
                              multiple
                              value={props.user.roles1}
                              onChange={e => props.handleChange(e)}
                              input={<Input />}
                              renderValue={selected => selected.join(', ')}
                              inputProps={{
                                name: `roles`,
                                id: `roles`
                              }}
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the role
                              </MenuItem>
                              {props.rolesList.map(role => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  key={role}
                                  value={role}
                                >
                                  {role}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            success={props.userState.uniqueName === 'success'}
                            error={props.userState.uniqueName === 'error'}
                            labelText="Unique Name*"
                            id="inputUniqueName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              type: 'text',
                              value: props.user.uniqueName,
                              endAdornment:
                                props.userState['uniqueName'] === 'error' ? (
                                  <InputAdornment position="end">
                                    <Close className={classes.danger} />
                                  </InputAdornment>
                                ) : (
                                  undefined
                                )
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <CustomInput
                            success={props.userState.email === 'success'}
                            error={props.userState.email === 'error'}
                            labelText="Email*"
                            id="inputEmail"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: true,
                              type: 'text',
                              value: props.user.email,
                              endAdornment:
                                props.userState['email'] === 'error' ? (
                                  <InputAdornment position="end">
                                    <Close className={classes.danger} />
                                  </InputAdornment>
                                ) : (
                                  undefined
                                )
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
                              Tenant*
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={props.user[`tenantId`]}
                              onChange={e => props.onFieldChange(`company`, e.target.value)}
                              inputProps={{
                                disabled: true,
                                name: `company`,
                                id: `company`
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the company
                              </MenuItem>
                              {props.companyList.map((company, index) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  style={{
                                    overflowX: 'auto',
                                    textOverflow: 'ellipsis'
                                  }}
                                  value={company.tenantId}
                                  key={index}
                                >
                                  {company.tenantId}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
                              Language*
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={props.user[`language`]}
                              onChange={e => props.onFieldChange(`language`, e.target.value)}
                              inputProps={{
                                name: `language`,
                                id: `language`
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the language
                              </MenuItem>
                              {[
                                { name: 'English', code: 'en' },
                                { name: 'Spanish', code: 'es' }
                              ].map((language, index) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  style={{
                                    overflowX: 'auto',
                                    textOverflow: 'ellipsis'
                                  }}
                                  value={language.code}
                                  key={index}
                                >
                                  {language.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
                              Locale*
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={props.user[`locale`]}
                              onChange={e => props.onFieldChange(`locale`, e.target.value)}
                              inputProps={{
                                name: `locale`,
                                id: `locale`
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the locale
                              </MenuItem>
                              {props.localeList.map((locale, index) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  style={{
                                    overflowX: 'auto',
                                    textOverflow: 'ellipsis'
                                  }}
                                  value={locale.locale.iso_639_with_country}
                                  key={index}
                                >
                                  {locale.locale.iso_639_with_country}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
                              Country*
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={props.user[`country`]}
                              onChange={e => props.onFieldChange(`country`, e.target.value)}
                              inputProps={{
                                name: `country`,
                                id: `country`
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the country
                              </MenuItem>
                              {props.countryList.map((country, index) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  style={{
                                    overflowX: 'auto',
                                    textOverflow: 'ellipsis'
                                  }}
                                  value={country.value}
                                  key={index}
                                >
                                  {country.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                          <FormControl fullWidth className={classes.selectFormControl}>
                            <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
                              User Type*
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={props.user[`type`]}
                              onChange={e => props.onFieldChange(`type`, e.target.value)}
                              inputProps={{
                                name: `type`,
                                id: `type`,
                                disabled: true
                              }}
                            >
                              <MenuItem
                                disabled
                                classes={{
                                  root: classes.selectMenuItem
                                }}
                              >
                                Select the type
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                style={{
                                  overflowX: 'auto',
                                  textOverflow: 'ellipsis'
                                }}
                                value={'thirdParty'}
                              >
                                Third Party
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                style={{
                                  overflowX: 'auto',
                                  textOverflow: 'ellipsis'
                                }}
                                value={'internal'}
                              >
                                Internal
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={6}>
                          <GridContainer justifyContent="flex-start" spacing={3}>
                            <GridItem xs={12} sm={12} md={12}>
                              <p>
                                Created By:
                                <span> {props.user?.createdBy?.userName ?? '-'}</span>
                              </p>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <p>
                                Date Created:
                                <span>
                                  {!props.user?.createdBy?.createDate
                                    ? ' -'
                                    : formatDate({
                                        date: props.user?.createdBy?.createDate,
                                        options: {
                                          year: 'numeric',
                                          month: '2-digit',
                                          day: '2-digit',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hourCycle: 'h23'
                                        }
                                      })}
                                </span>
                              </p>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={6}>
                          <GridContainer justifyContent="flex-start" spacing={3}>
                            <GridItem xs={12} sm={12} md={12}>
                              <p>
                                Updated By:
                                <span> {props.user?.updatedBy?.userName ?? '-'}</span>
                              </p>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <p>
                                Date Updated:
                                <span>
                                  {!props.user?.updatedBy?.updateDate
                                    ? ' -'
                                    : formatDate({
                                        date: props.user?.updatedBy?.updateDate,
                                        options: {
                                          year: 'numeric',
                                          month: '2-digit',
                                          day: '2-digit',
                                          hour: '2-digit',
                                          minute: '2-digit',
                                          hourCycle: 'h23'
                                        }
                                      })}
                                </span>
                              </p>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControlLabel
                            className={classes.activeToggle}
                            control={
                              <Switch
                                checked={props.user.enabled}
                                onChange={event =>
                                  props.onFieldChange('enabled', event.target.checked)
                                }
                                value="enabled"
                                classes={{
                                  switchBase: classes.switchBase,
                                  checked: classes.switchChecked,
                                  thumb: classes.switchIcon,
                                  track: classes.switchBar
                                }}
                              />
                            }
                            classes={{
                              label: classes.label
                            }}
                            label="Enabled"
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                  <div className={classes.formCategory}>
                    <small>*</small> Mandatory fields
                  </div>
                  <div className={classes.center}>
                    {props.isLoadingSave ? (
                      <CircularProgress color="inherit" />
                    ) : (
                      <Button color="primary" onClick={props.onUserSave}>
                        Save
                      </Button>
                    )}
                  </div>
                </form>
              </CardBody>
            </Card>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="User updated successfully"
              open={props.createSuccess}
              closeNotification={() => props.setCreateSuccess(false)}
              close
            />
            <Snackbar
              place="bl"
              color="danger"
              icon={AddAlert}
              message={props.validationMessage}
              open={props.createError}
              closeNotification={() => props.setCreateError(false)}
              close
            />
          </GridItem>
        </GridContainer>
      </div>
    </Fade>
  )
}
